export const registerTh = {
    formRegister: {
        register_lbl: 'ยืนยันข้อมูล',
        title: {
            label: 'คำนำหน้าชื่อ',
            required: 'กรุณาเลือกคำนำหน้าชื่อ',
            mr:{
                label:'นาย',
                placeholder: '',
                required: '',
                too_short: '',
                invalid: '',
            },
            mrs: {
                label:'นาง',
                placeholder: '',
                required: '',
                too_short: '',
                invalid: '',
            },
            miss: {
                label:'นางสาว',
                placeholder: '',
                required: '',
                too_short: '',
                invalid: '',
            }
        },
        gender: {
            label: 'เพศ',
            required: 'กรุณาเลือกเพศ',
            male: {
                label:'ชาย',
                placeholder: '',
                required: '',
                too_short: '',
                invalid: '',
            },
            female: {
                label:'หญิง',
                placeholder: '',
                required: '',
                too_short: '',
                invalid: '',
            },
            other: {
                label:'อื่นๆ',
                placeholder: '',
                required: '',
                too_short: '',
                invalid: '',
            }
        },
        firstname: {
            name: 'ชื่อ',
            placeholder: 'กรอกชื่อ',
            required: 'กรุณากรอกชื่อ',
            too_short: '',
            invalid: ''
        },
        lastname: {
            name: 'นามสกุล',
            placeholder: 'กรอกนามสกุล',
            required: 'กรุณากรอกนามสกุล',
            too_short: '',
            invalid: ''
        },

        birthdate: {
            name: 'วันเกิด',
            placeholder: '',
            required: 'required',
            too_short: '',
            invalid: 'รูปแบบวันเกิดไม่ถูกต้อง',
            invalid_age: 'คุณมีอายุต่ำกว่า 20 ปี',
            date: {
                name: '',
                defaultText: 'วัน',
                required: ''
            },
            month: {
                name: '',
                defaultText: 'เดือน',
                required: ''
            },
            year: {
                name: '',
                defaultText: 'ปี',
                required: ''
            },
        },

        contactnumber: {
            name: 'เบอร์โทรศัพท์',
            placeholder: 'กรอกเบอร์โทรศัพท์',
            required: 'กรอกเบอร์โทรศัพท์',
            too_short: '',
            invalid: '',
        },
        email: {
            name: 'อีเมล',
            placeholder: 'กรอกอีเมล',
            required: '',
            too_short: '',
            invalid: 'อีเมลไม่ถูกต้อง',
        },

        friendCode:{
            name: 'รหัสเพื่อน (ถ้ามี)',
            placeholder: 'กรอกรหัสผู้แนะนำ',
            required: '',
            too_short: '',
            invalid: '',
        },

        shipping: {
            headline: 'ที่อยู่ในการจัดส่ง',

            address: {
                name: 'ที่อยู่',
                placeholder: 'กรอกที่อยู่',
                required: 'กรุณากรอกที่อยู่',
                too_short: '',
                invalid: '',
            },
            zipcode: {
                name: 'รหัสไปรษณีย์',
                placeholder: 'รหัสไปรษณีย์',
                required: '',
                too_short: 'รหัสไปรษณีย์ต้องมี {0} หลัก',
                invalid: 'รหัสไปรษณีย์ไม่ถูกต้อง',
            },
            subdistrict: {
                name: 'แขวง/ตำบล',
                placeholder: 'เลือกแขวง/ตำบล',
                required: '',
                too_short: '',
                invalid: '',
            },
            district: {
                name: 'เขต/อำเภอ',
                placeholder: 'เลือกเขต/อำเภอ',
                required: '',
                too_short: '',
                invalid: '',
            },
            province: {
                name: 'จังหวัด',
                placeholder: 'เลือกจังหวัด',
                required: '',
                too_short: '',
                invalid: '',
            },
        }
    },

    terms: {
        i_agree: 'ฉันได้อ่านและยอมรับ',
        link_terms: 'นโยบายความเป็นส่วนตัว',
        and: 'และ',
        link_condition: 'เงื่อนไขการใช้งาน'
    },
    consent: {
        link_marketing: 'ข่าวสารและโปรโมชั่น',
        age: 'ฉันอายุ 20 ปีบริบูรณ์'
    },

    btn_register: 'ลงทะเบียน',
    btn_next: 'ถัดไป',
    btn_cancel: 'ยกเลิก',

    welcomePoint: {
        title: 'ยินดีต้อนรับสู่',
        text_success: 'คุณได้รับ Point<br>จากการสมัครสมาชิกสำเร็จ',
        text_welcome: 'และรับ Welcome Point',
    },
    alert:{
        text_title: 'เข้าสู่ระบบล้มเหลว',
        text_msg: 'LINE ID นี้มีอยู่ในระบบแล้ว',
        text_try: 'ลองอีกครั้ง',
    }
}

export const survey = {
    header: 'แบบสอบถาม',
    title: 'ปัญหาผิวหน้าของคุณเป็นอย่างไร',
    skin_type: {
        name: 'ประเภทของผิว',
        placeholder: 'เลือกประเภทผิวของคุณ',
        required: 'เลือกประเภทผิวของคุณ',
        too_short: '',
        invalid: '',
        defaultText: 'เลือกประเภทผิวของคุณ'
    },
    skin_issues: {
        title: 'ปัญหาผิวของคุณเป็นอย่างไร'
    },
    products_used: {
        name: 'ผลิตภัณฑ์ดูแลผิวหน้า',
        placeholder: 'ผลิตภัณฑ์ดูแลผิวหน้าของคุณ',
        required: 'ผลิตภัณฑ์ดูแลผิวหน้าของคุณ',
        too_short: '',
        invalid: '',
        defaultText: 'ผลิตภัณฑ์ดูแลผิวหน้าของคุณ'
    },
    other_product: {
        name: '',
        placeholder: 'โปรดระบุชื่อแบรนด์ผลิตอื่นๆที่ท่านใช้',
        required: '',
        too_short: '',
        invalid: '',
    }
}
